var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGcaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GCA_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 363.2 136.2",
    style: {
      enableBackground: "new 0 0 363.2 136.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GCA_Logo_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "GCA_Logo_4_",
    className: "st0",
    d: "M361.7,114.6L304.9,6.9c-2.2-4.2-6.5-6.8-11.3-6.8c-4.8,0-9.1,2.6-11.3,6.8 c0,0-25.6,48.2-35.4,66.9c-9.8,18.7-23,37-50.2,37c-26.8,0-48.6-19.1-48.6-42.6c0-23.5,21.8-42.6,48.6-42.6 c9.2,0,18.1,2.2,25.8,6.5c6.2,3.4,13.9,1.2,17.3-5c3.4-6.2,1.2-13.9-5-17.3C223.4,3.3,210.2,0,196.8,0c-36.1,0-66.3,23.9-72.8,55.4 H86.8c-7,0-12.7,5.7-12.7,12.7c0,7,5.7,12.7,12.7,12.7h33.7c-6.2,17.3-24.7,29.9-46.4,29.9c-26.8,0-48.6-19.1-48.6-42.6 s21.8-42.6,48.6-42.6c9.2,0,18.1,2.2,25.8,6.5c6.2,3.4,13.9,1.2,17.3-5c3.4-6.2,1.2-13.9-5-17.3C100.7,3.3,87.5,0,74.1,0 C33.2,0,0,30.6,0,68.1s33.2,68.1,74.1,68.1c25.5,0,48-11.9,61.4-30c13.3,18.1,35.9,30,61.4,30c40.9,0,60.2-27.6,67.2-40.2 c7.4-13.4,20.2-38.1,29.6-55.9l45.6,86.4c3.3,6.2,11,8.6,17.2,5.3C362.7,128.5,365,120.8,361.7,114.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcaLogo);
export default __webpack_public_path__ + "static/media/gca-logo.95c9698fa8fc34881645969d82102c56.svg";
export { ForwardRef as ReactComponent };